import React from 'react';
import '../template-file-css/document-file-template.css';


export const JHC_AdultPsychiatricAdvanceDirective = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='JHC_AdultPsychiatricAdvanceDirective' className='file-pdf-document'>
            <div className='file-template'>
                <p className='w-750'>
                    <b> <center> Psychiatric Advance Directive  </center> </b>
                </p>
                <p className='w-750'>
                    It is your right to have a written direction about your mental/health treatment, known as advanced directives, if you ever loose your ability to make a decision. This plan basically describes how you want to be cared for in case you are ever to become unable to decide or speak for yourself. You also have the right to revoke this consent at any point in time.
                </p>
                <p className='w-750'>
                    You may also include a 'healthcare proxy'.  This lets you name another person to make decisions about you care if you become unable to do so. For assistance in preparing these plans, we recommend that you speak to someone you trust. For example, one of our agency staff, a family member, or a minister. If you choose,  one of our staff can assist you,  and your mental health directive can be incorporated into the assessment, treatment, and services delivery process with our agency. You may also contact an advocacy agency for assistance and support in completing an advanced directive. The following is an advocacy contact information: <b> The ADVOCACY CENTER:  800-7111696.</b>
                </p>
                <p className='w-750'>
                    Psychiatric Advance Directives (PAD) are required for adults ages 18 and over in order to meet this standard, Jackson Hands of Change determines our clients status upon admission. Please select all selections applicable as it relates to you and your care needs.
                </p>

                <p className='w-750'>

                    <input type='checkbox' id='cbCareNeeds_1' name='cbCareNeeds_1' className='add-only' value='CareNeeds_1' /> I have a current PAD, the PAD has been reviewed by Jackson Hands of Change, Inc. and is available in my record.<br />
                    <input type='checkbox' id='cbCareNeeds_2' name='cbCareNeeds_2' className='add-only' value='CareNeeds_2' /> I do NOT have a PAD therefore:<br />
                    <input type='checkbox' id='cbCareNeeds_3' name='cbCareNeeds_3' className='add-only' value='CareNeeds_3' /> Jackson Hands of Change,  provided education on psychiatric advance directives.<br />
                    <input type='checkbox' id='cbCareNeeds_4' name='cbCareNeeds_4' className='add-only' value='CareNeeds_4' /> Jackson Hands of Change,  offered assistance in preparing a PAD whereas I <input type='radio' id='rbCareNeeds_4declined' name='rbCareNeeds_4' className='add-only' value='declined' /> declined <input type='radio' id='rbCareNeeds_4accepted' name='rbCareNeeds_4' className='add-only' value='accepted' /> 	  accepted
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Notes as applicable </span>
                    <textarea id='txtNotesApplicable' name='txtNotesApplicable' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Print  Client Name </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Agency Representative </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Signature of Client, Guardian or Personal Representative  </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                </table>


            </div>
        </form>

    )
}